import React from 'react';
import PropTypes from 'prop-types';
import LocalizedText from '@LocalizedText';
import './Toggle.scss';

const Toggle = ({
  onChange,
  isToggled,
  isDisabled,
  titleLocaleKey,
  stateOnLocaleKey,
  stateOffLocaleKey
}) => (
  <div data-testid="toggle" className="toggle" aria-disabled={isDisabled}>
    <span className="toggle__title">
      <LocalizedText id={titleLocaleKey} />
    </span>
    <label data-testid="toggle-control" className="toggle__control">
      <input type="checkbox" checked={isToggled} onChange={onChange} />
      <span className="toggle__inner">
        <span className='toggle__knob' />
      </span>
    </label>
    <span className='toggle__state'>
      <LocalizedText id={isToggled ? stateOnLocaleKey : stateOffLocaleKey} />
    </span>
  </div>
);

Toggle.propTypes = {
  onChange: PropTypes.func.isRequired,
  isToggled: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  titleLocaleKey: PropTypes.string.isRequired,
  stateOnLocaleKey: PropTypes.string.isRequired,
  stateOffLocaleKey: PropTypes.string.isRequired,
};

export default Toggle;